import React from "react";
import { Route } from "react-router-dom";
import ProtectedRoute from "../components/global/ProtectedRoute";

// Lazy Pages
const Tags = React.lazy(() => import("../pages/tags/Tags"));
const CreateTag = React.lazy(() => import("../pages/tags/CreateTag"));
const EditTag = React.lazy(() => import("../pages/tags/EditTag"));

const tagsRoutes = (
    <>
        {/* Tags List */}
        <Route
            path="/tags"
            element={
                <ProtectedRoute requiredPermission="catalog.manage">
                    <Tags />
                </ProtectedRoute>
            }
        />

        {/* Create Tag */}
        <Route
            path="/tags/create"
            element={
                <ProtectedRoute requiredPermission="catalog.manage">
                    <CreateTag />
                </ProtectedRoute>
            }
        />

        {/* Edit Tag */}
        <Route
            path="/tags/:id/edit"
            element={
                <ProtectedRoute requiredPermission="catalog.manage">
                    <EditTag />
                </ProtectedRoute>
            }
        />
    </>
);

export default tagsRoutes;
